import type { Project } from '@/entities/project';
import request from '@/shared/api/request';

export const renameProject = (uuid: string, name: string): Promise<{ project: Project }> =>
  request({
    url: `/projects/${uuid}/`,
    method: 'PUT',
    data: { name },
  });
